import $ from 'jquery';
import ReactDOM from 'react-dom';
import React from 'react';

import RoutingTestsMap from '../../components/here_maps/RoutingTestsMap';

import loadData from '../../lib/bootstrapped_data';
import autocompleteAddress from '../../utils/autocomplete_address.js';

const AdministrationRoutingTests = {
  viaPointCounter: 0,

  init() {
    this.renderRoutingTestsMap();
    this.initRequestOptionsToggle();
    this.bindAddViaPointButton();
    this.bindRemoveViaPointButton();
    this.populateViaPointsFromUrl();
  },

  renderRoutingTestsMap() {
    const mapEl = $('#js-map-container');
    if (!mapEl.length) return;

    const boundingBox = loadData('bbox');
    const routingTest = loadData('routing_test')?.data;
    const restrictedAreas = loadData('restricted_areas')?.data;

    ReactDOM.render(
        <RoutingTestsMap
            boundingBox={boundingBox}
            routingTest={routingTest}
            restrictedAreas={restrictedAreas}
        />,
        mapEl.get(0)
    );
  },

  initRequestOptionsToggle() {
      const toggleButton = document.getElementById('requestOptionsBtn');
      const preContent = document.getElementById('requestOptionsPreContent');

      if (toggleButton && preContent) {
          toggleButton.addEventListener('click', () => {
              const isCurrentlyVisible = getComputedStyle(preContent).display !== 'none';

              if (isCurrentlyVisible) {
                  preContent.style.display = 'none';
              } else {
                  preContent.style.display = 'block';
              }
          });
      }
  },

  bindAddViaPointButton() {
    const addViaPointButton = $('#add-dynamic-via-point');
    const viaPointTemplateHtml = $('#via-point-template').html();

    if (!addViaPointButton.length || !viaPointTemplateHtml) {
      console.error('Add Via Point button or template is missing.');
      return;
    }

    addViaPointButton.on('click', () => {
      const viaPointContainer = $('#via-points-container');
      if (!viaPointContainer.length) {
        console.error('Via Points container is missing.');
        return;
      }

      this.viaPointCounter++;
      const newViaPointHtml = viaPointTemplateHtml.replace(/{via_point_index}/g, this.viaPointCounter);
      const $newViaPointElement = $(newViaPointHtml);

      $newViaPointElement.find('input[name="routing_test[via_lats][]"]').val('');
      $newViaPointElement.find('input[name="routing_test[via_lngs][]"]').val('');
      $newViaPointElement.find('input[name="routing_test[via_headings][]"]').val('');
      $newViaPointElement.find('.js-autocomplete-address-widget input[type="text"]').val('');

      const $selectApproach = $newViaPointElement
          .find('select[name="routing_test[via_approaches][]"]');
      if ($selectApproach.length) {
        $selectApproach.val('street');
      } else {
        console.warn('Via approach select box not found in new via point template.');
      }

      viaPointContainer.append($newViaPointElement);

      const $newAutocompleteWidget = $newViaPointElement.find('.js-autocomplete-address-widget');
      const boundingBox = loadData('bounding_box');
      autocompleteAddress.init($newAutocompleteWidget, { bounds: boundingBox });

      this.updateViaPointNumbers();
    });
  },

  bindRemoveViaPointButton() {
    $('#via-points-container').on('click', '.remove-via-point-btn', (event) => {
      $(event.target).closest('.via-container').remove();
      this.updateViaPointNumbers();
    });
  },

  updateViaPointNumbers() {
    $('#via-points-container .via-point-number').each((index, element) => {
      $(element).text(index + 1);
    });
  },

  populateViaPointsFromUrl() {
    const queryParams = new URLSearchParams(window.location.search);
    const viaPointContainer = $('#via-points-container');
    const viaPointTemplateHtml = $('#via-point-template').html();

    if (!viaPointContainer.length || !viaPointTemplateHtml) {
      console.error('Via Points container or template is missing for populateViaPointsFromUrl.');
      return;
    }

    viaPointContainer.empty();

    const viaLats = queryParams.getAll('routing_test[via_lats][]');
    const viaLngs = queryParams.getAll('routing_test[via_lngs][]');
    const viaHeadings = queryParams.getAll('routing_test[via_headings][]');
    const viaApproaches = queryParams.getAll('routing_test[via_approaches][]');

    viaLats.forEach((lat, index) => {
      this.viaPointCounter++;
      const lng = viaLngs[index] || '';
      const heading = viaHeadings[index] || '';
      const approach = viaApproaches[index] || 'street';

      const newViaPointHtml = viaPointTemplateHtml.replace(/{via_point_index}/g, this.viaPointCounter);
      const $newViaPointElement = $(newViaPointHtml);

      $newViaPointElement.find('input[name="routing_test[via_lats][]"]').val(lat);
      $newViaPointElement.find('input[name="routing_test[via_lngs][]"]').val(lng);
      $newViaPointElement.find('input[name="routing_test[via_headings][]"]').val(heading);

      const $selectApproach = $newViaPointElement
          .find('select[name="routing_test[via_approaches][]"]');
      if ($selectApproach.length) {
        $selectApproach.val(approach);
      } else {
        console.warn(`Via approach select box not found for index ${index}.`);
      }

      viaPointContainer.append($newViaPointElement);

      const $newAutocompleteWidget = $newViaPointElement.find('.js-autocomplete-address-widget');
      const boundingBox = loadData('bounding_box');
      autocompleteAddress.init($newAutocompleteWidget, { bounds: boundingBox });
    });

    if (viaLats.length > 0) {
      this.updateViaPointNumbers();
    }
  }
};

export default AdministrationRoutingTests;
